import { supabase } from "./supabaseClient";

// Survey data structure
const surveyData = [
  {
    question_text: "Which best describes your current role?",
    question_order: 1,
    options: [
      {
        option_text: "Student (University / College / Bootcamp)",
        option_order: 1,
      },
      {
        option_text: "Aspiring Developer (Self-taught / Career Changer)",
        option_order: 2,
      },
      {
        option_text: "Professional Software Engineer / Developer",
        option_order: 3,
      },
      { option_text: "Data Scientist / Analyst", option_order: 4 },
    ],
  },
  {
    question_text:
      "What is your main reason for learning Data Structures & Algorithms?",
    question_order: 2,
    options: [
      { option_text: "Coding interviews / job placements", option_order: 1 },
      {
        option_text: "Skill improvement for work or projects",
        option_order: 2,
      },
      { option_text: "Competitive programming", option_order: 3 },
      { option_text: "Academic / coursework support", option_order: 4 },
      { option_text: "Personal growth / curiosity", option_order: 5 },
    ],
  },
  {
    question_text: "How would you describe your current DSA experience?",
    question_order: 3,
    options: [
      { option_text: "Just starting out (new to DSA)", option_order: 1 },
      {
        option_text: "Know the basics (arrays, loops, simple sorting)",
        option_order: 2,
      },
      {
        option_text: "Comfortable with intermediate concepts (trees, graphs)",
        option_order: 3,
      },
      {
        option_text:
          "Experienced (LeetCode, coding contests, real problem-solving)",
        option_order: 4,
      },
    ],
  },
];

/**
 * Setup survey questions and options in the database
 * Run this function once to populate the tables
 */
export async function setupSurveyTables() {
  console.log("Starting survey setup...");

  for (const questionData of surveyData) {
    // Insert question
    const { data: question, error: questionError } = await supabase
      .from("landing_survey_questions")
      .insert([
        {
          question_text: questionData.question_text,
          question_order: questionData.question_order,
        },
      ])
      .select()
      .single();

    if (questionError) {
      console.error("Error inserting question:", questionError);
      continue;
    }

    console.log("Inserted question:", question.question_text);

    // Insert options for this question
    const optionsToInsert = questionData.options.map((opt) => ({
      question_id: question.id,
      option_text: opt.option_text,
      option_order: opt.option_order,
    }));

    const { error: optionsError } = await supabase
      .from("landing_survey_options")
      .insert(optionsToInsert);

    if (optionsError) {
      console.error("Error inserting options:", optionsError);
    } else {
      console.log(`Inserted ${optionsToInsert.length} options for question`);
    }
  }

  console.log("Survey setup complete!");
}

/**
 * Fetch all questions and their options from the database
 */
export async function fetchSurveyQuestions() {
  const { data: questions, error: questionsError } = await supabase
    .from("landing_survey_questions")
    .select(
      `
      id,
      question_text,
      question_order,
      landing_survey_options (
        id,
        option_text,
        option_order
      )
    `
    )
    .order("question_order", { ascending: true });

  if (questionsError) {
    console.error("Error fetching questions:", questionsError);
    return null;
  }

  // Sort options by option_order
  questions.forEach((q) => {
    if (q.landing_survey_options) {
      q.landing_survey_options.sort((a, b) => a.option_order - b.option_order);
    }
  });

  return questions;
}

/**
 * Save survey responses to the database
 * @param {string} email - User's email
 * @param {Array} responses - Array of {question_id, option_id}
 */
export async function saveSurveyResponses(email, responses) {
  const responsesToInsert = responses.map((r) => ({
    question_id: r.question_id,
    option_id: r.option_id,
    email: email,
  }));

  const { data, error } = await supabase
    .from("landing_survey_response")
    .insert(responsesToInsert);

  if (error) {
    console.error("Error saving survey responses:", error);
    throw error;
  }

  console.log("Successfully saved survey responses:", data);
  return data;
}
